import Header from './components/Header'
import Footer from './components/Footer'
import { Container } from 'react-bootstrap'
import HomeScreen from './screens/HomeScreen';
import { BrowserRouter as Router,Route, Routes } from 'react-router-dom'
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ProfileScreen from './screens/ProfileScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import PayResultScreen from './screens/PayResultScreen';
import PrivateRoute from './utils/PrivateRoute';
import AbfaScreen from './screens/AbfaScreen';
import CustomerScreen from './screens/CustomerScreen';
import ProductsScreen from './screens/ProductsScreen';
import PasargadPayResultScreen from './screens/PasargadPayResultScreen';
import PasargadReportScreen from './screens/PasargadReportScreen';
import PostScreen from './screens/PostScreen';
import PasargadInquiryScreen from './screens/PasargadInquiryScreen';
import OrderGeneralScreen from './screens/OrderGeneralScreen';

function App() {
  return (
    <Router>
     <Header/>
     <main>
      <Container>
        <Routes>
        <Route path='/' Component={HomeScreen} exact />
        {/* <Route path='/abfa' Component={AbfaScreen} exact /> */}
        <Route element={<PrivateRoute />}>
                <Route element={<PayResultScreen/>} path="/payresult"/>
                <Route element={<ProfileScreen/>} path='/profile'  />
                <Route element={<AbfaScreen/>} path='/abfa'  />
                <Route element={<PostScreen/>} path='/post'  />
                <Route element={<PasargadReportScreen/>} path='/pasargad'  />
                <Route element={<PasargadInquiryScreen/>} path='/inquiry'  />
                <Route element={<CustomerScreen/>} path='/customer/:id'  />
            </Route>
        <Route path='/product/:id' Component={ProductScreen} />
        <Route path='/products/:id' Component={ProductsScreen} />
        <Route path='/login' Component={LoginScreen} />
        <Route path='/shipping' Component={ShippingScreen} />
        {/* <Route path='/mainpage?' Component={ShippingScreen} /> */}
        <Route path='/payment' Component={PaymentScreen} />
        <Route path='/placeorder' Component={PlaceOrderScreen} />
        <Route path='/order/:kit/:id' Component={OrderScreen} />
        <Route path='/orders' Component={OrderGeneralScreen} />
        <Route path='/payresult/:id/:authority/:refId' Component={PayResultScreen} />
        <Route path='/pasargadpayresult/:id/:referenceNumber/:trackId' Component={PasargadPayResultScreen} />
        <Route path='/register' Component={RegisterScreen} />
        <Route path='/cart/:id?' Component={CartScreen} />
       
        </Routes>
      
      </Container>
     </main>
     <Footer/>
    </Router>
  );
}

export default App;
